import {
  type TableColumnFormatBoolean,
  getValueFromKeyOfType,
  makeFormatBooleanTableCellValue,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { maybeWrapNonEmptyWithLink } from 'components/Table/cells/helpers/maybeWrapWithLink';
import {
  ARRAY_CELL_MAX_ITEMS,
  maybeWrapWithMore,
} from 'components/Table/cells/helpers/trimLargeArray';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderBooleanCell = <TRow,>(
  format: TableColumnFormatBoolean<TRow>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const content = getValueFromKeyOfType(row, format.field);

  const formatValue = makeFormatBooleanTableCellValue(format.options);

  return {
    content: pipe(
      Array.isArray(content)
        ? pipe(
            content,
            (a) => a.slice(0, ARRAY_CELL_MAX_ITEMS),
            array.map(formatValue),
            (a) => a.join(', '),
            maybeWrapWithMore(content),
          )
        : formatValue(content),
      maybeWrapNonEmptyWithLink(
        row,
        severity !== null,
        format.createLinkProps,
        !context.disableLinks,
      ),
    ),
  };
};
